import { createActions } from 'reduxsauce';

var _createActions = createActions({
  requestAdd: function requestAdd() {
    return {
      type: 'WISHLIST_ADD'
    };
  },
  recieveAdd: function recieveAdd() {
    return {
      type: 'WISHLIST_ADD_RECIEVE'
    };
  },
  requestRemove: function requestRemove() {
    return {
      type: 'WISHLIST_REMOVE'
    };
  },
  recieveRemove: function recieveRemove() {
    return {
      type: 'WISHLIST_REMOVE_RECIEVE'
    };
  },
  requestGet: ['requestGet'],
  receiveGet: function receiveGet(json) {
    return {
      type: 'WISHLIST_RECEIVE_GET',
      results: json
    };
  }
}, {
  prefix: 'WISHLIST_'
}),
    Creators = _createActions.Creators,
    Types = _createActions.Types;

export default {
  Creators: Creators,
  Types: Types
};